<template>
    <secition-card
        title="많이 방문한 페이지"
        v-bind="{
            titleActionProps: { to: '/console/statistics/current' },
            loading,
        }"
    >
        <v-data-table
            v-bind="{
                headers,
                items,
                'items-per-page': -1,
                'mobile-breakpoint': -1,
            }"
            hide-default-footer
            disable-filtering
            disable-pagination
            disable-sort
            dense
        >
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }">
                <span :key="header.text" :title="header.formatter(value)"> {{ header.formatter(value) }} </span>
            </template>
        </v-data-table>
    </secition-card>
</template>

<script>
import api from "@/api";
import SecitionCard from "@/components/console/dumb/secition-card.vue";

export default {
    components: {
        SecitionCard,
    },
    props: {
        searchDateValue: { type: Array, default: () => [null, null] },
    },
    data: () => ({
        ranks: [],

        loading: false,
    }),
    computed: {
        headers() {
            return [
                {
                    text: "URL",
                    value: "_id",
                    cellClass: "text-truncate",
                    formatter: (value) => value || "직접방문",
                },
                {
                    text: "조회수",
                    value: "count",
                    width: 80,
                    align: "end",
                    formatter: (value) => `${value.format()}건`,
                },
            ].map((item) => ({ ...item, cellClass: `${item.cellClass || ""} text-caption` }));
        },
        items() {
            return this.ranks || [];
        },
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { searchDateValue } = this;
                const { ranks } = await api.console.statistics.visits.gets({
                    params: { searchDateValue },
                    headers: { limit: 10, mode: "current-ranks" },
                });
                this.ranks = ranks;
            } finally {
                this.loading = false;
                this.$emit("updated");
            }
        },
    },
    watch: {
        searchDateValue() {
            this.search();
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    td.text-truncate {
        max-width: 0;
    }
}
</style>